module.exports = __webpack_public_path__ + "static/media/dsr_bg3.80c0be9a.png";